export const RECEIVING_METHOD_FORM_NAME = 'receivingMethodForm';
export const RECEIVING_METHOD_BANK_ACCOUNT_FORM_NAME = 'receivingMethodBankAccountForm';
export const BENE_PERSONAL_DETAILS_FORM_NAME = 'benePersonalDetailsForm';
export const BENE_BANK_DETAILS_FORM_NAME = 'beneBankDetailsForm';
export const BENE_FORM = 'beneAddOrEditForm';

export const screenNames = {
  receiving_method: {
    name: 'receiving_method',
    header: 'Add Recipient',
    formNames: [RECEIVING_METHOD_FORM_NAME, RECEIVING_METHOD_BANK_ACCOUNT_FORM_NAME],
    isCloseButtonVisible: true,
    isBackButtonVisible: true
  },
  personal_details: {
    name: 'personal_details',
    header: 'Recipient Info',
    formNames: [BENE_PERSONAL_DETAILS_FORM_NAME],
    isCloseButtonVisible: true,
    isBackButtonVisible: true
  },
  bank_details: {
    name: 'bank_details',
    header: 'Recipient bank details',
    formNames: [BENE_BANK_DETAILS_FORM_NAME],
    isCloseButtonVisible: true,
    isBackButtonVisible: true
  },
  recipient_address: {
    name: 'recipient_address',
    header: 'Recipient address',
    formNames: [],
    isCloseButtonVisible: true,
    isBackButtonVisible: true
  },
  recipient_added: {
    name: 'recipient_added',
    header: 'Recipient added',
    formNames: [],
    isCloseButtonVisible: true,
    isBackButtonVisible: false
  }
};

export const EXIT_BENEFICIARY_FLOW_ALERT_MESSAGE_CONSTANTS = {
  heading: 'Are you sure you want to exit?',
  description: 'If you exit now, the progress won’t be saved and you will need to start over.',
  primaryCtaText: 'Stay here',
  secondaryCtaText: 'Exit now'
};
export const LABELS = {
  availble_partner: 'At any partner location',
  bankDeposit: 'Bank deposit',
  cashPickup: 'Cash pickup',
  debitCard: 'Debit card',
  geoSwift: 'Bank card',
  money_gram: 'At MoneyGram locations',
  wallet: 'Wallet'
};

export const BENE_V3_FIELDS = {
  is_legal_last_name_provided: false,
  card_token: '',
  payout_method: '',
  beneficiary_account_type: '',
  beneficiary_identification_type: '',
  beneficiary_identification_value: '',
  beneficiary_account_number: '',
  beneficiary_bank_name: '',
  beneficiary_name: '',
  beneficiary_contact_number: '',
  beneficiary_contact_country_code: '',
  beneficiary_email: '',
  beneficiary_bank_code: '',
  beneficiary_bank_account_type: '',
  beneficiary_identity_number: ''
};

export const PAYEE_DETAILS_FORM = {
  full_name: '',
  nickname: '',
  company_name: '',
  account_type: '',
  currency_code: '',
  date_of_birth: '',
  nationality: '',
  mobile_country_code: '',
  mobile_number: '',
  email: '',
  bank_account_number: '',
  country_code: '',
  bank_account_country: '',
  bank_name: '',
  trade_name: '',
  remitter_beneficiary_relationship: '',
  re_enter_account_number: '',
  routing_code_value_1: '',
  routing_code_value_2: '',
  routing_code_value_3: '',
  additional_id_value_1: '',
  additional_id_value_2: '',
  additional_id_value_3: '',
  additional_id_value_4: '',
  additional_id_value_5: '',
  unit_number: '',
  street_number: '',
  street: '',
  street_name: '',
  street_type: '',
  suburb: '',
  state: '',
  block_number: '',
  floor_number: '',
  building_name: '',
  district: '',
  address1: '',
  address2: '',
  city: '',
  postcode: '',
  additional_info: {
    social_credit_code: '',
    organization_code: ''
  },
  building_number: '',
  province: '',
  card_number: '',
  card_expiry_date: '',
  routing_config_type: '',
  card_holder_name: '',
  card_issuer_name: '',
  proxy_type: '',
  proxy_value: '',
  ...BENE_V3_FIELDS
};
